import FullBleedContent from '../Page/FullBleedContent';

export default FullBleedContent;
